<div class="carousel"
     #carousel
     (swipe)="onSwipe($event)"
     [style.touch-action]="'pan-y'"
>
  <ul class="track" #track>
    <li *ngFor="let item of slides" [style.width.px]="isBrowser ?  slideWidth : '100%'">
      <ng-container
        [ngTemplateOutlet]="item.tpl"
      ></ng-container>
    </li>
  </ul>

  <div class="indicators-wrapper">
    <ul class="indicators">
      <li
        class="indicator"
        *ngFor="let item of slides; let i = index"
        [class.active]="i === slideIndicator"
        (click)="onIndicatorClick(i)"
      ></li>
    </ul>
  </div>

  <ng-container *ngLet="resizeObserver$ | async"></ng-container>
</div>
